export class SessionStatusBroadcastMessagePayload {
	public Username: string;

	constructor(username: string) {
		this.Username = username;
	}

	public AsJson(): string {
		const messagePayload = { Username: this.Username };
		const messagePayloadInJson = JSON.stringify(messagePayload);

		return messagePayloadInJson;
	}
}
